function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import { styled } from 'styled-components';
import { colors } from '../../abstracts';
import { dontForwardProps } from '../../util';
const SvgContainer = styled.div.withConfig(dontForwardProps()).withConfig({
  displayName: "SvgContainer",
  componentId: "asurion-ui-react__sc-17vfvy9-0"
})(["position:relative;vertical-align:middle;width:", ";height:", ";"], ({
  width
}) => width, ({
  width
}) => width);
const StyledSvg = styled.svg.withConfig({
  displayName: "StyledSvg",
  componentId: "asurion-ui-react__sc-17vfvy9-1"
})(["display:block;width:100%;height:100%;#eSOCNY03Vh62_tr{animation:eSOCNY03Vh62_tr__tr 4000ms linear infinite normal forwards;}@keyframes eSOCNY03Vh62_tr__tr{0%{transform:translate(12px,11.982764px) rotate(0deg);}100%{transform:translate(12px,11.982764px) rotate(1440deg);}}#eSOCNY03Vh63{animation:eSOCNY03Vh63_s_do 4000ms linear infinite normal forwards;}@keyframes eSOCNY03Vh63_s_do{0%{stroke-dashoffset:120;animation-timing-function:cubic-bezier(0.42,0,0.58,1);}50%{stroke-dashoffset:0;animation-timing-function:cubic-bezier(0,0,0.58,1);}100%{stroke-dashoffset:119;}}"]);
export const InlineLoader = ({
  width = '2.5rem',
  title,
  disabled,
  ...rest
}) => /*#__PURE__*/React.createElement(SvgContainer, {
  width: width,
  "data-aui": "loader"
}, /*#__PURE__*/React.createElement(StyledSvg, _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  shapeRendering: "geometricPrecision",
  textRendering: "geometricPrecision",
  "aria-describedby": title && 'loader-title'
}, rest), title && /*#__PURE__*/React.createElement("title", {
  id: "loader-title"
}, title), /*#__PURE__*/React.createElement("g", {
  id: "eSOCNY03Vh62_tr",
  transform: "translate(12,11.982764) rotate(0)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "scale(0.374102,0.374102) translate(-172.009537,-224.748871)"
}, /*#__PURE__*/React.createElement("path", {
  id: "eSOCNY03Vh63",
  d: "M16.740383,-21.819392C23.282934,-16.792264,27.5,-8.888607,27.5,0C27.5,15.187831,15.187831,27.5,0,27.5s-27.5-12.312169-27.5-27.5c0-11.228019,6.728981-20.884399,16.374237-25.156435",
  transform: "translate(172.009536 224.748878)",
  fill: "rgba(84,131,204,0)",
  stroke: disabled ? colors.disabledText : colors.black,
  strokeWidth: "6",
  strokeLinecap: "square",
  strokeDashoffset: "120",
  strokeDasharray: "143.36"
})))));

/** @deprecated `LoadingSpinnerProps` has been renamed to `InlineLoaderProps`. */

/** @deprecated `AsurionLoadingSpinner` has been renamed to `InlineLoader`. */
export const AsurionLoadingSpinner = InlineLoader;